// Install ("Приложение") — standalone install-section: centered intro + OS tabs
// + the animated device mockup (shared DeviceMockup component).

import { useState } from 'react'
import styles from './Install.module.css'
import DeviceMockup from './DeviceMockup'

export default function Install() {
  const [os, setOs] = useState('ios')
  return (
    <div className={styles.wrap}>
      <div className={styles.intro}>
        <h1>Добавьте на<br />главный экран</h1>
        <p>Humanteq будет всегда под рукой — как обычное приложение. Обновлять не нужно.</p>
      </div>

      <div className={styles.osTabs}>
        <button className={`${styles.osTab} ${os === 'ios' ? styles.osActive : ''}`} onClick={() => setOs('ios')}>
          Для айфона
        </button>
        <button className={`${styles.osTab} ${os === 'android' ? styles.osActive : ''}`} onClick={() => setOs('android')}>
          Для андроида
        </button>
      </div>

      <DeviceMockup os={os} />
    </div>
  )
}
